import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import { Fade, Zoom } from 'react-awesome-reveal'
import AZ from '../../assets/logos/logo2.png'
import AZD from '../../assets/logos/AL.png'
import { Link } from 'react-router-dom'
import './ServiceGrid.css'

const services = [
  {
    id: 1,
    image: 'images/services/service1.jpg',
    title: 'Sécurité résidentielle et industrielle',
    link: '/Securite-residentielle-industrielle',
    texts: 'GEKAS Security and Consulting SARL propose un service de sécurité résidentielle et industrielle conçu pour offrir une protection optimale aux ...',
  },
  {
    id: 2,
    image: 'images/services/service2.jpg',
    title: 'Protection rapprochée',
    link: '/Protection-rapprochee',
    texts: 'Chez GEKAS Security and Consulting SARL, le service de protection rapprochée est dédié à la sécurité des personnes à haut profil, qu’il s’agisse ...',
  },
  {
    id: 3,
    image: 'images/services/service3.jpg',
    title: 'Surveillance de sites miniers',
    link: '/Surveillance-de-sites-minierse',
    texts: 'GEKAS Security and Consulting SARL met à disposition son expertise pour la surveillance de sites miniers, un domaine hautement stratégique exposé ...',
  },
  {
    id: 4,
    image: 'images/services/service4.jpg',
    title: 'Transport sécurisé',
    link: '/Transport-securise',
    texts: 'Le service de transport sécurisé proposé par GEKAS Security and Consulting SARL vise à garantir la sécurité des personnes, des biens sensibles et ...',
  },

]

const ServiceGrid = () => {
  return (
    <section
      id="main-container"
      className="main-container pb-5 pt-5"
      style={{
        backgroundImage: 'url(images/assets/ban6.jpg)',
 backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        backgroundPosition: 'center',
        borderTop: '10px #917232 solid',
        backdropFilter: 'blur(2px)',
      }}
    >
      <div className="container">
        <div className="text-center mb-5">
          <Zoom>
            <img src={AZ} alt="logo" className="img-fluid mb-3" style={{ maxWidth: 300 }} />
          </Zoom>
          <h2
            className="section-title fw-bold"
            style={{
              color: '#fac56a',
              textShadow: '0 0 10px #917232',
              fontSize: '2.5rem',
              fontWeight: '700',
            }}
          >
            Service d'Excellence
          </h2>
        </div>

        <div className="row">
          {services.map((service, index) => (
            <div className="col-12 col-md-6 col-lg-3 mb-4" key={service.id}>
              <Fade direction="up" delay={index * 100} triggerOnce>
                <div
                  className="shadow-lg service-card"
                  style={{
                    background: 'rgba(255, 255, 255, 0.04)',
                    border: '1px solid rgba(255, 255, 255, 0.15)',
                    borderRadius: '20px',
                    backdropFilter: 'blur(12px)',
                    WebkitBackdropFilter: 'blur(12px)',
                    transition: 'transform 0.4s ease, box-shadow 0.3s ease',
                    cursor: 'pointer',
                    overflow: 'hidden',
                    height: '430px',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)'
                    e.currentTarget.style.boxShadow = '0 15px 25px rgba(0,0,0,0.3)'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)'
                    e.currentTarget.style.boxShadow = '0 5px 15px rgba(0,0,0,0.1)'
                  }}
                >
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-100"
                    style={{ height: '200px', objectFit: 'cover' }}
                  />
                  <div className="d-flex p-3">
                    <img
                      src={AZD}
                      alt="icon"
                      style={{ width: '60px', height: '30px', marginRight: '15px' }}
                    />
                    <div>
                      <h5 className="fw-bold mb-2" style={{ color: '#f7ca77' }}>
                        <Link to={service.link} className="text-decoration-none" style={{ color: '#f7ca77' }}>
                          {service.title}
                        </Link>
                      </h5>
                      <p className="text-white-50" style={{ fontSize: '14px', lineHeight: '1.4' }}>
                        {service.texts}
                      </p>
                      <Link to={service.link} className="text-light text-decoration-none">
                        <i className="fa fa-caret-right me-2"></i>Plus d'infos
                      </Link>
                    </div>
                  </div>
                </div>
              </Fade>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ServiceGrid
